'use client';

import { useRouter } from 'next/navigation';

interface TagChipProps {
  label: string;
  count?: number;
  size?: 'sm' | 'md';
  active?: boolean;
  onClick?: (label: string) => void;
  /** When true, clicking the chip navigates to /dashboard/community?tag={label}. */
  navigate?: boolean;
}

export default function TagChip({ label, count, size = 'sm', active = false, onClick, navigate = false }: TagChipProps) {
  const router = useRouter();

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onClick) {
      onClick(label);
      return;
    }
    if (navigate) {
      router.push(`/dashboard/community?tag=${encodeURIComponent(label)}`);
    }
  };

  const sizeClasses = size === 'md' ? 'text-sm px-3 py-1' : 'text-xs px-2 py-0.5';
  const stateClasses = active
    ? 'bg-purple-500/25 text-purple-200 border-purple-400/30'
    : 'bg-purple-500/10 text-purple-300 border-purple-500/15 hover:bg-purple-500/20 hover:text-purple-200';

  const interactive = onClick || navigate;

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={!interactive}
      className={`inline-flex items-center gap-1 rounded-full border transition-all font-medium ${sizeClasses} ${stateClasses} ${
        interactive ? 'cursor-pointer' : 'cursor-default'
      }`}
    >
      <span>#{label}</span>
      {typeof count === 'number' && (
        <span className="text-purple-300/50 text-[10px] tabular-nums">{count.toLocaleString()}</span>
      )}
    </button>
  );
}
